import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';

/**
 * Automatically selects the latest version of a content submission via the
 * `versionId` search param. Preserves the current `versionId` if it belongs
 * to the current content submission; otherwise falls back to `latestVersionId`.
 */
function useAutoSelectLatestVersion(
  contentSubmissionId: string | undefined,
  latestVersionId: string | null | undefined,
  versionIds: string[] | undefined
) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const currentVersionId = searchParams.get('versionId');

    // Preserve the current version if it belongs to this content submission
    if (currentVersionId && versionIds?.includes(currentVersionId)) {
      return;
    }

    if (!latestVersionId) {
      return;
    }

    setSearchParams(
      (prev) => ({...Object.fromEntries(prev), versionId: latestVersionId}),
      {replace: true}
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentSubmissionId, latestVersionId]);

  return searchParams.get('versionId');
}

export default useAutoSelectLatestVersion;
